<script setup>
import {onMounted, ref, defineAsyncComponent, watch, computed} from "vue";
  import { getCurrencySymbol } from "@/utils/currency.js"
  import { formatBalanceWithCommas } from "@/utils/numbers.js"

  import { useStore } from 'vuex'
  const vuexStore = useStore()

  const BaseSelect = defineAsyncComponent(() =>
      import(/* webpackChunkName: "BaseSelect" */ '@/components/base/selects/BaseSelect.vue')
  );

  const selectedActivesCurrency = ref(null)

  const showMe = computed(() => {
    return vuexStore.getters['activesByCurrencies'] && vuexStore.getters['activesByCurrencies'].length
  })

  watch(() => vuexStore.getters['activesByCurrencies'], (v) => {
    if (v.length) {
      selectedActivesCurrency.value = v[0]
    }
  })

  onMounted(() => { //
    vuexStore.dispatch('refreshExchangeRates')
  })
</script>

<template>
  <div v-if="showMe" class="common-actives">
    <BaseSelect
      v-model="selectedActivesCurrency"
      :label="`${text('actives.common')}:`"
      :placeholder="text('actives.common')"
      :options="vuexStore.getters['activesByCurrencies']"
    >
      <template #select-value="data">
        <div class="actives-item">
          <div>
            {{ formatBalanceWithCommas(data.amount) }} <span class="symbol">{{ getCurrencySymbol(data.currency_code) }}</span>
          </div>
        </div>
      </template>
      <template #select-option-value="data">
        <div class="actives-item">
          {{ data.currency_code }}
          <div class="amount">
            {{ formatBalanceWithCommas(data.amount) }} <span class="symbol">{{ getCurrencySymbol(data.currency_code) }}</span>
          </div>
        </div>
      </template>
    </BaseSelect>
  </div>

</template>

<style scoped>
  .common-actives {
    .base-select-wrapper :deep(.select) {
      min-height: 75px;
      max-height: 75px;

      background: linear-gradient(15deg, var(--element-bg) 0%, var(--element-bg) 70%, var(--accent-bg-50) 100%);

      ::before {
        content: '';
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 0;
        width: 2px;
        height: 42px;
        background-color: var(--accent-bg);
      }

      .value {
        display: flex;
        align-items: center;
        gap: 15px;
        width: fit-content;
        margin-top: 5px;

        &::after {
          content: url("data:image/svg+xml;utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='13' viewBox='0 0 8 13' fill='none'%3E%3Cpath d='M1.30029 0.666748L6.18056 5.29016C6.87446 5.94754 6.87446 7.05262 6.18056 7.71L1.30029 12.3334' stroke='white' stroke-width='1.25' stroke-linecap='round'/%3E%3C/svg%3E");
          display: inline-block;
          width: 8px;
          height: 17px;
        }
      }
      .chevron {
        display: none;
      }
    }
    .base-select-wrapper :deep(.select-options) {
      top: 85px;

      @media (max-width: 920px) {
        top: unset;
      }
    }
    .actives-item {
      width: 100%;

      display: flex;
      align-items: center;
      justify-content: space-between;

      gap: 8px;

      font-size: 18px;

      min-height: 25px;

      .amount {
        display: flex;
        align-items: center;
        justify-content: end;
        gap: 6px;

        .symbol {
          color: var(--text-color-secondary);
        }
      }
    }

    @media (max-width: 920px) {
      .base-select-wrapper :deep(.select) {
        min-height: 75px;
        max-height: 75px;

        background: linear-gradient(15deg, var(--layout-bg) 0%, var(--layout-bg) 70%, var(--accent-bg-50) 100%);
      }
    }
  }
</style>